import { Box } from '@mui/material';
import { FC } from 'react';
import { useRescheduleRequestView } from '../../../../hooks/use-reschedule-request-view';
import { GeneralPatientInfo } from '../../../../shared/general-patient-info/general-patient-info';
import { LabeledText } from '../../../../shared/labeled-text/labeled-text';

export const PatientDetailsSection: FC = (props) => {
  const { requestDetails, contact } = useRescheduleRequestView();

  return (
    <>
      <GeneralPatientInfo requestDetails={requestDetails} contact={contact} />
      <Box sx={{ margin: '0 25px' }}>
        <LabeledText label="Source">RW AI</LabeledText>
      </Box>
    </>
  );
};
